import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useFinishImportServiceJobsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportServiceJobsJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			systemJobId,
			options,
			impersonationContext,
		}: {
			systemJobId: string;
			options: Api.IImportServiceJobsOptions;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IImportServiceJobsJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `ServiceJob/importFromFile/${systemJobId}`,
				}),
				'POST',
				options
			);
		},
		onError,
		onSuccess,
		retry: false,
	});
};
